import { isNil } from '../../../util/object';
import ERRORS from '../errors';

const existingActionTypes = new Set();

/**
 * Note this wrapper must be listed immediately before the action function it's wrapping because it will use the name of the action function
 * to create the action
 *
 * @param REDUX_NAMESPACE - A prefix to the action type, used to group actions together under a common namespace
 */
const actionCreator = (REDUX_NAMESPACE) => {
  const namespace = REDUX_NAMESPACE;

  if (isNil(namespace)) {
    throw new ERRORS.RequiredActionNamespaceError();
  }

  /**
   * We'll prefix the actionType with given namespace and ':'.
   * We use the function name as the action name.
   **/

  return (target, key, descriptor) => {
    const actionFunction = descriptor.value;
    const functionName = actionFunction.name;

    const actionType = `${namespace}:${functionName}`;

    // Don't let people create the same action type in the same red
    if (existingActionTypes.has(actionType)) {
      throw new ERRORS.DuplicateActionTypeError(functionName);
    }

    // Add the type to the literal returned by the action creator
    const wrapperFunction = (...args) => {
      const actionObjectLiteral = actionFunction.apply(target, args) || {};
      actionObjectLiteral.type = actionType;
      return actionObjectLiteral;
    };
    wrapperFunction.TYPE = actionType;
    // Support using the action creator as a key in handler & sagas
    wrapperFunction.toString = () => actionType;

    // Overwrite the original creator with the wrapperFunction
    descriptor.value = wrapperFunction;

    // Remember that this actionType is accounted for, so that no duplicates show up.
    existingActionTypes.add(actionType);

    return descriptor;
  };
};

export default actionCreator;
